"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsService = void 0;
class MetricsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    getApiV1Metrics() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/Metrics',
        });
    }
    getApiV1Metrics1({ context }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/Metrics/{context}',
            path: {
                context: context,
            },
        });
    }
    getApiV1MetricsContexts() {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/Metrics/contexts',
        });
    }
    getApiV1MetricsGenerate({ sizeInMb, maxUnique, }) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/Metrics/generate/{sizeInMB}',
            path: {
                sizeInMB: sizeInMb,
            },
            query: {
                maxUnique: maxUnique,
            },
        });
    }
}
exports.MetricsService = MetricsService;
